import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FFPaper from '../../shared/FFPaper';
import * as React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import Title from '../../shared/Title';
import { FunctionComponent } from 'react';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import ChartContainer from '../../shared/ChartContainer';

const handler = (menu: string) => {
    console.log(menu);
}

const chartData = [
    { name: 'African American', value: 700 },
    { name: 'Other', value: 100 },
    { name: 'Asian', value: 300 },
    { name: 'Unknown', value: 100 },
    { name: 'Caucasian', value: 200 }
];

const COLORS = ['#21539B', '#A0D5FF', '#0275D8', '#67676734', '#7B8491'];

const RADIAN = Math.PI / 180;


type CircleLegendProps = {
    label: string,
    color: string
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color }) => {
    return (
        <Stack direction="column" sx={{ alignItems: 'left', width: '180px' }} spacing={1}>
            <Stack direction="row" sx={{
                padding: '4px 10px 4px 2px',
                alignItems: 'center'
            }}>
                <Box sx={{
                    width: 20,
                    borderRadius: '50%',
                    height: 20,
                    backgroundColor: color,
                }}>&nbsp;
                </Box>
                <Typography sx={{
                    padding: '5px 10px 10px 10px',
                    verticalAlign: 'center',
                }}>
                    {label}
                </Typography>
            </Stack>
        </Stack>
    )
}

const renderCustomizedLabel = (data: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {

    const radius = data.innerRadius + (data.outerRadius - data.innerRadius) * 0.5;
    const x = data.cx + radius * Math.cos(-data.midAngle * RADIAN);
    const y = data.cy + radius * Math.sin(-data.midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central" fontSize={11} >
            {`${(data.percent * 100).toFixed(0)}%`}
        </text>
    );
};


function WeekTrafficPieChart() {

    const renderLegend = (props: any) => {
        const { payload } = props;

        return (
            <Box sx={{ 
                pl: {
                    xs: 1,
                    sm: 2,
                    md: 8
                }
            
            , display: 'flex', flexWrap: 'wrap', maxHeight: '150px', height: '150px', width: '500px' }}>
                {
                    payload.map((entry: any, i: number) => {
                        const { payload: item } = entry;
                        const label = `${item.name}`
                        return (
                            <CircleLegend key={i} label={label} color={entry.color} />
                        )
                    })
                }
            </Box>
        )
    }

    return (
        <React.Fragment>
            <ResponsiveContainer >
                <PieChart  >
                    <Pie
                        data={chartData}
                        labelLine={false}
                        innerRadius={55}
                        outerRadius={100}
                        cx={150}
                        cy={100}
                        dataKey="value"
                        label={renderCustomizedLabel}

                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Legend content={renderLegend} />
                </PieChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}


export default function TrafficByGenerationDemographicsCard() {
    const info = 'Measures the amount of weekend traffic vs week traffic';

    return (

        <Grid item={true} xs={12} md={12} lg={4} >
            <FFPaper
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    justifyContent: 'top',
                    height: '100%'
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />
                <Box sx={{
                    p: '8px'
                }}>
                    <Title big={true} info={info} notooltip={true}>Traffic by Ethnicity</Title>
                </Box>
                <Box sx={{ 
                        display: 'flex', 
                        width: '100%', 
                        height: '100%', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative' }}>
                    <Box sx={{
                        width: {
                            xs: '100%',
                            sm : '60%',
                            md: '60%',
                            lg: '90%'
                        },
                        mt: 0,
                    }}>
                        <Box sx={{
                            height: 380,
                            pt: 1
                        }}>
                            <ChartContainer>
                                <WeekTrafficPieChart />
                            </ChartContainer>
                        </Box>
                    </Box>
                    <Typography
                        sx={{
                            position: 'absolute',
                            left: {
                                xs: '40%',
                                sm: '37%',
                                md: '65%',
                                lg: '73%'
                            },
                            top: '23%',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            fontSize: '25px',
                        }}
                    >11,529</Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            position: 'absolute',
                            left: {
                                xs: '40%',
                                sm: '37%',
                                md: '65%',
                                lg: '73%'
                            },
                            top: '33%',
                            color: 'text.primary'
                        }}
                    >Total Traffic</Typography>

                </Box>
            </FFPaper>
        </Grid>

    )

}
